module.exports = "https://images.shiksha.ws/saassets/media/LeftArrowActive.13a338d3.png";